const payment = () => {
    document.addEventListener('DOMContentLoaded', function () {
        var radio = document.getElementById('ContentPlaceHolder1_rdbManual') as HTMLInputElement;
        var payRadio = Array.from(document.getElementsByClassName('pay-radio'));
        payRadio.forEach((value: HTMLInputElement) => {
            value.addEventListener('change',
                () => {
                    var manualPay = document.getElementsByClassName('manual-pay')[0] as HTMLElement;
                    if (radio.checked) {
                        manualPay.style.display = "block";
                    } else {
                        manualPay.style.display = "none";
                    }
                });
        });
    });
};

export {
    payment
};